import InvitationFlowPage from './InvitationFlowPage';

const InvitationFlowPageLeasing: React.FC = () => {
  return <InvitationFlowPage team="leasing" />;
};

export default InvitationFlowPageLeasing;
